import { api } from "@/api/axios.ts";
import { ApiEmployeeEmploymentHistoryData } from "@/types/employees/employee-employment-history.types.ts";

export const apiEmployeeEmploymentHistory = {
  getAll: async function (employeeId: number) {
    return api.get<ApiEmployeeEmploymentHistoryData>(
      `/api/v1/employees/${employeeId}/employment-history`
    );
  },
};
